/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} B2b_Feat_2_DescInputs */

const en_b2b_feat_2_desc = /** @type {(inputs: B2b_Feat_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automated, compliant PDF receipt generation featuring your Legal Business Name and Tax ID on every transaction.`)
};

const es_b2b_feat_2_desc = /** @type {(inputs: B2b_Feat_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generación automática de recibos PDF que muestran el Nombre Legal de tu Negocio y tu ID Fiscal en cada transacción.`)
};

const fr_b2b_feat_2_desc = /** @type {(inputs: B2b_Feat_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Génération automatisée et conforme de reçus PDF comportant votre nom légal et votre numéro de TVA sur chaque transaction.`)
};

const de_b2b_feat_2_desc = /** @type {(inputs: B2b_Feat_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische, konforme PDF-Quittungserstellung mit deinem gesetzlichen Firmennamen und deiner Steuernummer bei jeder Transaktion.`)
};

const id_b2b_feat_2_desc = /** @type {(inputs: B2b_Feat_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembuatan tanda terima PDF yang patuh dan otomatis, menampilkan Nama Resmi Bisnis dan NPWP Anda di setiap transaksi.`)
};

/** @type {(inputs: B2b_Feat_2_DescInputs) => LocalizedString} */
const ja_b2b_feat_2_desc = en_b2b_feat_2_desc;

/** @type {(inputs: B2b_Feat_2_DescInputs) => LocalizedString} */
const zh_b2b_feat_2_desc = en_b2b_feat_2_desc;

/** @type {(inputs: B2b_Feat_2_DescInputs) => LocalizedString} */
const ar_b2b_feat_2_desc = en_b2b_feat_2_desc;

/** @type {(inputs: B2b_Feat_2_DescInputs) => LocalizedString} */
const it_b2b_feat_2_desc = en_b2b_feat_2_desc;

/** @type {(inputs: B2b_Feat_2_DescInputs) => LocalizedString} */
const ru_b2b_feat_2_desc = en_b2b_feat_2_desc;

/** @type {(inputs: B2b_Feat_2_DescInputs) => LocalizedString} */
const pt_b2b_feat_2_desc = en_b2b_feat_2_desc;

/** @type {(inputs: B2b_Feat_2_DescInputs) => LocalizedString} */
const ko_b2b_feat_2_desc = en_b2b_feat_2_desc;

/**
* | output |
* | --- |
* | "Automated, compliant PDF receipt generation featuring your Legal Business Name and Tax ID on every transaction." |
*
* @param {B2b_Feat_2_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const b2b_feat_2_desc = /** @type {((inputs?: B2b_Feat_2_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<B2b_Feat_2_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_b2b_feat_2_desc(inputs)
	if (locale === "es") return es_b2b_feat_2_desc(inputs)
	if (locale === "fr") return fr_b2b_feat_2_desc(inputs)
	if (locale === "de") return de_b2b_feat_2_desc(inputs)
	if (locale === "ja") return ja_b2b_feat_2_desc(inputs)
	if (locale === "zh") return zh_b2b_feat_2_desc(inputs)
	if (locale === "ar") return ar_b2b_feat_2_desc(inputs)
	if (locale === "id") return id_b2b_feat_2_desc(inputs)
	if (locale === "it") return it_b2b_feat_2_desc(inputs)
	if (locale === "ru") return ru_b2b_feat_2_desc(inputs)
	if (locale === "pt") return pt_b2b_feat_2_desc(inputs)
	return ko_b2b_feat_2_desc(inputs)
});